import { Maximize2, Minimize2 } from 'lucide-react'
import { useEffect, useState } from 'react'

import { Button, Heading, Text } from '@ankor-io/ui-components'

export const DashboardHeader = () => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  useEffect(() => {
    const onFullscreenChange = () => {
      setIsFullscreen(Boolean(document.fullscreenElement))
    }

    document.addEventListener('fullscreenchange', onFullscreenChange)
    return () => document.removeEventListener('fullscreenchange', onFullscreenChange)
  }, [])

  const toggleFullscreen = async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen()
      } else {
        await document.documentElement.requestFullscreen()
      }
    } catch {
      // Fullscreen may be blocked by the browser; ignore silently for TV kiosk setups
    }
  }

  return (
    <header className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
      <div>
        <Heading level={3}>Admin Dashboard</Heading>
        <Text className="text-gray-600 dark:text-gray-400">Platform-wide overview and system status.</Text>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        {/* TODO: Bring back in when system status is implemented (issue-3329 branch) */}

        <div className="flex items-center gap-2">
          {/* TODO: Bring back in when report month selector is implemented (issue-3329 branch) */}
          <Button
            outline
            onClick={toggleFullscreen}
            aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
          >
            {isFullscreen ? (
              <Minimize2
                data-slot="icon"
                aria-hidden
              />
            ) : (
              <Maximize2
                data-slot="icon"
                aria-hidden
              />
            )}
          </Button>
        </div>
      </div>
    </header>
  )
}
